import dayjs from 'dayjs';

export const getTodaysDate = () => {
  return dayjs().startOf('day');
};
export const getTodaysDateMYD = () => {
  return dayjs().startOf('day').format('YYYY-MM-DD');
};
